export default __webpack_public_path__ + "./images/lt.fe5562a5.png";